import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-637ecff1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plan-card-header-wrapper d-flex justify-center" }
const _hoisted_2 = { class: "plan-card-header align-self-center plan-amount mt-n5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"font-weight":"normal","font-size":"60px"},
  class: "pr-2"
}, "₹", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle-2 d-flex justify-center mt-n5" }, "Truly Unlimited ", -1))
const _hoisted_5 = { class: "plan-card-content d-flex justify-center mt-15" }
const _hoisted_6 = { class: "plan-card-header align-self-center speed mt-n5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle-1 d-flex justify-center mt-n3" }, "/Month ", -1))
const _hoisted_8 = { class: "plan-card-content d-flex justify-center mt-11 mx-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_jt_book_now_button = _resolveComponent("jt-book-now-button")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_jt_plan_details = _resolveComponent("jt-plan-details")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "plan-card mobile-view" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(_toDisplayString($props.item?.price) + " ", 1),
          _hoisted_4
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString($props.item?.mode == 1 ? $props.item?.speed : $props.item?.yearly) + " Mbps ", 1),
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_jt_book_now_button, {
          onGetBookNowStatus: $setup.getBookNowStatus,
          item: $props.item
        }, null, 8, ["onGetBookNowStatus", "item"]),
        _createVNode(_component_v_spacer),
        ($setup.show)
          ? (_openBlock(), _createBlock(_component_v_dialog, {
              key: 0,
              activator: "parent"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_jt_plan_details, {
                  item: $props.item,
                  onClosePopup: _cache[0] || (_cache[0] = ($event: any) => ($setup.closePopup()))
                }, null, 8, ["item"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_btn, {
          class: "btn-secondary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.show = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode("View details ")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}